/**
 * Web version of useWalletAvailability hook.
 * Digital wallet provisioning is not available on web, so this always returns false.
 */
const useWalletAvailability = (): boolean => {
  return false;
};

export default useWalletAvailability;
